import Edit from './edit.vue';

export default {
  Edit,
};
